import React from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <div className="social">
       {/* <a href="https://x.com/ipproject2025" target="_blank" rel="noopener noreferrer"><RiTwitterXLine /></a> */}
         <a href="https://t.me/vmines_network" target="_blank" rel="noopener noreferrer"><FaTelegramPlane /></a>
      </div>
      <p>Copyright@2026: Vmines Network all rights reserved</p>
    </div>
  );
};

export default Footer;
